import Vue from "vue";
export const eventBus = new Vue();

export default ({ Vue }) => {
  Vue.prototype.$eventBus = eventBus;
};
